<template>
	<el-card class="cartbox" shadow="never">
		<div slot="header" class="flexBetween">
			<h3>商品清单</h3>

			<!-- <el-link type="primary" @click="goto({ path: '/index/Cart' })">返回购物车</el-link> -->
			<el-button type="primary" size="small" plain @click="goto({ path: '/Cart' })">返回购物车</el-button>
		</div>
		<div class="carttable">
			<table v-for="(group, index) in cartSettle" :key="index" class="rgoodbox goodbox-item">
				<tr class="goods-th">
					<td :rowspan="group.list.length + 1" class="shuoming" width="21%">
						<div v-if="group.isDigit == 0" class="ps-box">
							<!-- <div class="ps-title">
								<strong>配送服务</strong>
							</div> -->
							<div class="ps-content">
								<div class="ps-title">
									<strong>纸质版图书</strong>
								</div>
								<div class="ps-content">您购买的纸质版文件，若平台收录了该文件的电子版，您支付完成后可在“个人中心 — 我的订单”中对应订单页面点击“在线阅读”按钮免费阅读</div>
								<!-- <p></p> -->
								<!-- <p>今日发货 三日内送达</p> -->
								<!-- <p> 尽快发货 </p> -->
							</div>
						</div>
						<div v-else-if="group.isDigit > 0" class="ps-box">
							<div class="ps-title">
								<strong>电子版图书（PDF文件）</strong>
							</div>
							<div class="ps-content">支付完成后可在“个人中心 — 我的订单 — 图书订单”中对应订单页面点击“下载PDF”按钮下载</div>
						</div>
						<div v-else class="ps-box">
							<div class="ps-title">
								<strong>额外添加图书</strong>
							</div>
							<div class="ps-content">请先提交订单，定价后可在“个人中心 — 我的订单 — 图书订单”中对应订单进行支付</div>
						</div>
					</td>
					<td>商品名称</td>
					<td class="tc" width="18%">价格</td>
					<td class="tc" width="7%">数量</td>
					<td class="tc" width="8%">总计</td>
				</tr>
				<tr v-for="info in group.list" :key="'rgood-' + info.id">
					<td>
						<span :class="info.isDigit == 0 ? 'colorblue' : info.isDigit == 1 ? 'colorgreen' : info.isDigit == 2 ? 'colorred' : 'colororange'"
							>【{{ info.isDigit == 0 ? '纸质版' : info.isDigit == 1 ? '电子版' : info.isDigit == 2 ? '结构化版' : '额外添加' }}】</span
						>

						<span>{{ formatProductName(info) }}</span>
						<!-- {{info.standardCode?info.standardCode:''}} {{ info.spuName }} -->
						<span class="cart-item-type-badge" v-if="getStandardTypeName(info.standardTypeId)">{{ getStandardTypeName(info.standardTypeId) }}</span>

						<!-- <p class="sku">{{ info.skuName }}</p> -->
					</td>
					<td class="tc" style="text-align: left">
						<div class="product-price" v-if="info.isDigit !== null">
							<span class="now-price">￥{{ getDisplayPrice(info) }}</span>
							<span class="before-price" v-if="info.fixedPrice && getDisplayPrice(info) < info.fixedPrice">￥{{ info.fixedPrice }}</span>
							<el-tag v-if="calculateDiscount(info) !== null" size="mini" type="danger" class="discount-tag">{{ (calculateDiscount(info) * 10).toFixed(1) }}折</el-tag>
						</div>
						<div v-else class="pending-price">待定价</div>
						<!-- <div> -->
						<!-- <em class="vip-price"> VIP会员价格：{{ info.vipPrice }}元</em> -->
						<!-- </div> -->
					</td>
					<td class="tc">{{ info.buyNum }}</td>
					<td class="tc">
						<div v-if="info.isDigit !== null">{{ totalRow(getDisplayPrice(info), info.buyNum) }}元</div>
						<div v-else>--</div>
					</td>
				</tr>
			</table>
		</div>

		<f-info></f-info>
	</el-card>
</template>

<script>
	import Y from '@/utils/Y';
	import { mapGetters, mapState, mapActions } from 'vuex';
	import FInfo from './FInfo.vue';
	export default {
		data() {
			return {};
		},
		components: {
			FInfo
		},

		computed: {
			...mapGetters('Cart', ['cartSettle', 'isVipUser', 'getDisplayPrice', 'calculateDiscount', 'getStandardTypeName'])
		},

		mounted() {
			this.fetchStandardType();
		},
		methods: {
			...mapActions('Cart', ['fetchStandardType']),
			//计算某一行的合计
			totalRow(price, num) {
				return (price * num).toFixed(2);
			},
			formatProductName(item) {
				if (item.isDigit == 0 && !item.skuId) {
					return item.spuName;
				}
				if (item.spuName && item.standardCode && item.spuName.indexOf(item.standardCode) !== -1) {
					return item.spuName;
				}
				return item.standardCode ? item.standardCode + ' ' + item.spuName : item.spuName;
			}
		}
	};
</script>
<style lang="less" scoped>
	em {
		font-style: normal;
	}
	.cartbox {
		margin-bottom: 20px;
		background-color: #ffffff;
		box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
		border-radius: 15px;
		h3 {
			margin: 0;
			font-weight: 400;
			font-size: 18px;
			color: #333333;
		}
	}
	.goodbox-item {
		width: 100%;
		margin-bottom: 20px;
		border-collapse: collapse;
		color: #333333;
		font-size: 14px;
		background-color: #ffffff;
		box-shadow: inset 0px 0px 5px 0px rgba(20, 116, 226, 0.5);
		border-radius: 2px;
		td {
			padding: 15px 20px;
			border-right: 1px solid #d0e3f9;
			border-bottom: 1px solid #d0e3f9;
		}
		td:last-child {
			border-right: 1px solid transparent;
		}
		.goods-th {
			color: #686f83;
		}
		.shuoming {
			vertical-align: text-top;
		}
		.ps-box {
			color: #686f83;
		}
		.ps-title {
			margin-bottom: 10px;
			color: #333333;
		}
		.ps-content {
			color: #888888;
			font-size: 13px;
			p {
				margin: 0 0 5px;
			}
		}
		.tfoot {
			text-align: right;
			background-color: rgba(227, 238, 255, 0.5);
			td {
				border-bottom: 1px solid transparent;
			}
			.o-info {
				margin-bottom: 6px;
			}
			span + span {
				margin-left: 20px;
			}
			em {
				font-style: normal;
				color: #ec2b2d;
			}
			.rprice {
				color: #ec2b2d;
				font-size: 16px;
				font-weight: bold;
			}
		}
	}

	.before-price {
		font-size: 12px;
		color: #94a3b8;
		text-decoration: line-through;
		margin-right: 10px;
	}

	.now-price {
		font-size: 20px;
		font-weight: 800;
		color: #ef4444;
		line-height: 1;
		letter-spacing: -0.3px;
		margin-right: 4px;
	}

	.pending-price {
		color: #f97316;
		font-size: 16px;
		font-weight: 600;
	}

	.vip-price {
		color: #1474e2;
		margin-top: 4px;
		display: inline-block;
		font-size: 12px;
	}

	.sku {
		color: #909399;
		font-size: 12px;
		margin: 8px 0;
		line-height: 18px;
	}

	.cart-item-type-badge {
		background: linear-gradient(135deg, #ef4444, #f97316);
		color: #ffffff;
		font-size: 11px;
		font-weight: 600;
		padding: 2px 8px;
		border-radius: 4px;
		vertical-align: middle;
		display: inline-block;
		margin-left: 8px;
	}

	/deep/ .el-link.el-link--primary {
		color: #333333;
	}
	/deep/ .el-link.el-link--primary:hover {
		color: #1474e2;
	}
	/deep/ .el-link.is-underline:hover:after {
		border-bottom: none;
	}
	/deep/ .el-card__header {
		padding: 30px 30px 0;
		border-bottom: none;
	}
	/deep/ .el-card__body,
	.el-main {
		padding: 20px 30px;
	}
	/deep/ .el-button--text {
		color: #333333;
		padding: 0;
	}
	/deep/ .el-button--text:hover {
		color: #1474e2;
	}
</style>
